export enum ProxyRequestStatus {
  PENDING_REVIEW = 'pending_review',
  PENDING_SUBMISSION = 'pending_submission',
}
